import axios from "axios";

export default async function getStockOutSummary(params = {}) {
  try {
    const response = await axios.get(
      "/distributor/system-admin/summary/v1/data-summary/view-stockout-reporting-summary",
      {
        params,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch stock out summary:", error);
    throw error.response?.data || error;
  }
}
